import { nanoid } from "nanoid";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { PlusIcon } from "../../../icons/PlusIcon";
import { BuilderList } from "../../FormGeneratorTypes";
import {
  Button,
  FormErrorMessage,
  SimpleGrid,
  FormControl,
  Input,
  IconButton,
} from "@chakra-ui/react";
import { ErrorMessage } from "@hookform/error-message";
import { DeleteIcon } from "../../../icons/DeleteIcon";

type InputListProps = {
  required: boolean;
  builder: BuilderList;
  name: string;
};

const ListInputs = ({ required, builder, name }: InputListProps) => {
  const {
    formState: { errors },
    register,
    control,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAddInput = () => {
    append({ id: nanoid(), valueA: "", valueB: "" });
  };

  useEffect(() => {
    if (builder?.inputList) {
      append(builder.inputList);
    }
  }, [builder?.inputList, append]);

  return (
    <>
      <FormControl>
        {fields?.map((field, index) => (
          <SimpleGrid
            key={field?.id}
            gap={4}
            gridTemplateColumns={{ base: "1fr", md: "1fr 1fr 50px" }}
          >
            <FormControl
              isInvalid={!!errors?.[name]}
              my={2}
            >
              <Input
                {...register(`${name}.${index}.valueA`, {
                  required: required ? `${builder?.field1} is required` : false,
                })}
                placeholder={builder?.field1}
                isInvalid={!!errors?.[name]}
                borderRadius={0}
              />

              <FormErrorMessage mb={2}>
                <ErrorMessage
                  errors={errors}
                  name={`${name}.${index}.valueA`}
                />
              </FormErrorMessage>
            </FormControl>
            <FormControl
              isInvalid={!!errors?.[name]}
              my={2}
            >
              <Input
                {...register(`${name}.${index}.valueB`, {
                  required: required ? `${builder?.field2} is required` : false,
                })}
                placeholder={builder?.field2}
                isInvalid={!!errors?.[name]}
                borderRadius={0}
              />
              <FormErrorMessage mb={2}>
                <ErrorMessage
                  errors={errors}
                  name={`${name}.${index}.valueB`}
                />
              </FormErrorMessage>
            </FormControl>
            <IconButton
              aria-label="delete row"
              onClick={() => remove(index)}
              disabled={fields.length === 1}
              variant="ghost"
              fontWeight={900}
              icon={<DeleteIcon />}
              mt={2}
            />
          </SimpleGrid>
        ))}
        <Button
          onClick={handleAddInput}
          variant="ghost"
          leftIcon={
            <PlusIcon
              w="14px"
              h="14px"
            />
          }
          size="sm"
          fontWeight={700}
          w="fit-content"
        >
          Add Field
        </Button>
      </FormControl>
    </>
  );
};

export default ListInputs;
